import { gameState } from '@js/state';

export default class HintScene extends Phaser.Scene {
  constructor() {
    super({ key: 'HintScene' });
  }

  preload() {}

  create() {
    this.timesclicked = 0;

    this.hintAnimations();
    this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0).setAlpha(0);

    this.hintText = this.add.image(72, 656, 'hintText').setOrigin(0, 1).setScale(0);

    this.text1 = this.add
      .text(
        95,
        630,
        'To find an equivalent fraction we can multiply\n\nthe numerator and denominator of the fraction\n\nby the same non-zero number.\n\n ',
        { fontFamily: 'font2', fontSize: '18px', fill: '#000000' },
      )
      .setOrigin(0, 1)
      .setDepth(1)
      .setScale(0);

    this.hintButton = this.physics.add
      .sprite(-25, 550, 'hintFinalAnim')
      .setOrigin(0)
      .setScale(0.8)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    this.hintButton.on('pointerdown', () => {
      gameState.hints++;
      this.hintButton.play('idle');
      this.scene.pause('GameScene');
      this.overlay.setAlpha(1);

      this.tweens.add({
        targets: [this.hintText, this.text1],
        scale: 1,
        duration: 500,
        ease: 'Sine.easeInOut',
        onComplete: () => {
          this.hintClose.setAlpha(1);
        },
      });
    });

    this.hintClose = this.add
      .image(516, 406, 'hintClose')
      .setOrigin(0)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.hintClose.on('pointerdown', () => {
      this.scene.resume('GameScene');
      this.overlay.setAlpha(0);
      this.hintText.setScale(0);
      this.text1.setScale(0);

      this.hintClose.setAlpha(0);
      this.hintButton.play('pop_out');
    });
  }

  hintAnimations() {
    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 1,
      repeat: -1,
    });

    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 60,
      repeat: 0,
    });
  }

  update() {
    if (gameState.clicked) {
      this.hintButton.setVisible(false);

      this.timesclicked++;
      gameState.clicked = false;

      if (this.timesclicked == 1) {
        this.time.delayedCall(1900, () => {
          this.load.plugin(
            'rexkawaseblurpipelineplugin',
            'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexkawaseblurpipelineplugin.min.js',
            true,
          );
          this.load.multiatlas(
            'endConfetti',
            'assets/EndSceneAssets/confetti/confettiAnimNew.json',
            'assets/EndSceneAssets/confetti',
          );
          this.load.multiatlas(
            'glitter',
            'assets/anims/rewardAnims/glitterAnim.json',
            'assets/anims/rewardAnims/',
          );

          this.load.image('compass', 'assets/anims/rewardAnims/compass.png');

          this.load.audio('yay', 'assets/Audio/yay.wav');

          this.load.image('gameOver', 'assets/EndSceneAssets/Game Over.png');
          this.load.image('youWon', 'assets/EndSceneAssets/You won.png');
          this.load.image('correctIcon', 'assets/EndSceneAssets/correctIcon.png');
          this.load.image('incorrectIcon', 'assets/EndSceneAssets/incorrectIcon.png');
          this.load.image('retryButton', 'assets/EndSceneAssets/Retry Button.png');
          this.load.image('hover_retryButton', 'assets/EndSceneAssets/hover_Retry Button.png');
          this.load.image('hintIconMini', 'assets/EndSceneAssets/endHint.png');
          this.load.image('nextButton', 'assets/EndSceneAssets/nextButton.png');
          this.load.image('hover_nextButton', 'assets/EndSceneAssets/hover_nextbutton.png');
          this.load.image('replayButton', 'assets/EndSceneAssets/replayButton.png');
          this.load.image('hover_replayButton', 'assets/EndSceneAssets/hover_replayButton.png');
          this.load.image('endScreenOverlay', 'assets/EndSceneAssets/end screen.png');
          this.load.image('okayButton', 'assets/EndSceneAssets/okaybutton.png');
          this.load.image('hover_okayButton', 'assets/EndSceneAssets/hover_okaybutton.png');
          this.load.image('disable_okayButton', 'assets/EndSceneAssets/disable_okaybutton.png');
          this.load.image('rewardEarned', 'assets/EndSceneAssets/Rewards earned!.png');
          this.load.image('rewardName', 'assets/EndSceneAssets/pot.png');
          this.load.start();
        });
      } else if (this.timesclicked == 2) {
        this.time.delayedCall(1850, () => {
          this.load.multiatlas(
            'spotlight',
            'assets/EndSceneAssets/spotlight/spotlightAnimNew.json',
            'assets/EndSceneAssets/spotlight',
          );
          this.load.start();
        });
      } else if (this.timesclicked == 3) {
        this.time.delayedCall(1900, () => {
          this.load.multiatlas(
            'baseCircle',
            'assets/anims/rewardAnims/baseCircleAnim.json',
            'assets/anims/rewardAnims/',
          );
          this.load.start();
        });
      } else if (this.timesclicked == 4) {
        this.time.delayedCall(1900, () => {
          this.load.multiatlas(
            'rewardLight',
            'assets/anims/rewardAnims/rewardLightAnim.json',
            'assets/anims/rewardAnims/',
          );
          this.load.start();
        });
      }
    }

    if (gameState.attempts == 2) {
      this.hintText.setTexture('hintText');

      if (gameState.level == 1) {
        this.text1.text =
          'By what number do we multiply 2 to get 8?\n\nCan we multiply 7 by the same number to get\n\nthe missing denominator?\n\n';
      } else if (gameState.level == 2) {
        this.text1.text =
          'By what number do we divide 9 to get 3?\n\nCan we divide 12 by the same number to get\n\nthe missing denominator?\n\n';
      } else if (gameState.level == 3) {
        this.text1.text =
          'By what number do we divide 5 to get 1?\n\nCan we divide 15 by the same number to get\n\nthe missing denominator?\n\n';
      } else if (gameState.level == 4) {
        this.text1.text =
          'By what number do we divide 8 to get 4?\n\nCan we divide 16 by the same number to get\n\nthe missing denominator?\n\n';
      } else if (gameState.level == 5) {
        this.text1.text =
          'By what number do we divide 4 to get 1?\n\nCan we divide 20 by the same number to get\n\nthe missing denominator?\n\n';
      } else if (gameState.level == 6) {
        this.text1.text =
          '4/8 = 1/2. What should 1 be multiplied by to get 3?\n\nCan we multiply 2 by the same number to find\n\nthe missing denominator?\n\n ';
      } else if (gameState.level == 7) {
        this.text1.text =
          '10/12 = 5/6. What should 1 be multiplied by to get 3?\n\nCan we multiply 2 by the same number to find\n\nthe missing denominator?\n\n ';
      } else {
        this.text1.text =
          'Find the equivalent fraction of the simplest form\n\nwith the given numerator or denominator.\n\n\n';
      }
    } else {
      this.hintText.setTexture('hintText');
      if (
        gameState.level == 1 ||
        gameState.level == 2 ||
        gameState.level == 3 ||
        gameState.level == 4 ||
        gameState.level == 5
      ) {
        this.text1.text =
          'To find an equivalent fraction we can multiply\n\nthe numerator and denominator of the fraction\n\nby the same non-zero number.\n\n ';
      } else {
        this.text1.text =
          'What is the fraction in its simplest form?\n\n\n\n ';
      }
    }

    if (gameState.attempts == 0) {
      this.hintButton.setVisible(false);
    }
    if (gameState.hneed && gameState.attempts > 0) {
      gameState.hneed = false;
      this.hintButton.setVisible(true);
      this.hintButton.play('pop');
      this.time.delayedCall(600, () => {
        this.hintButton.play('breathe');
      });
    }
  }
}
